module.exports = __webpack_public_path__ + "static/media/phone.6369235.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Melon/phone.mp4
// module id = Bwqu
// module chunks = 1